const UPLOAD_LIMIT_GB = 5;
const UPLOAD_LIMIT = UPLOAD_LIMIT_GB * Math.pow(2, 30); // in GB

// The maximum part size is 100 MB.
const MULTIPART_SIZE = Math.pow(2, 20) * 100;

export { UPLOAD_LIMIT_GB, UPLOAD_LIMIT, MULTIPART_SIZE };
